// src/routes/allRoutes.tsx
import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import Root from "../pages/Root/index";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/register/CompanyRegister";
import ChangePassword from "../pages/Authentication/ChangePassword";
import CreateNewPassword from "../pages/Authentication/NewPassword";
import LockScreen from "../pages/Authentication/LockScreen";
import OnboardingWizard from "../pages/Authentication/OnboardingWizard";
import Dashboard from "../pages/Dashboard/index";
import StarterPage from "../pages/StarterPage/index";
import TaskBoardPage from "../pages/Dashboard/TaskBoard/TaskBoardPage";
import SettingsLayout from "../pages/ProfilleSettings/SettingsLayout";
import ProcessIndex from "../pages/Dashboard/Process/index";
import { ChatJessPage } from "../pages/Dashboard/ChatJess";
import GoogleOnboarding from "../pages/Authentication/GoogleOnboarding";
import ConnectorsPage from "../pages/Dashboard/Connectors/ConnectorsPage";
import ConnectionsPage from "../pages/Dashboard/Connections/ConnectionsPage";
import OAuthCallback from "../pages/OAuth/OAuthCallback";
import ChatLoadingFallback from "../components/ChatLoadingFallback";
import SuperAdminProtected from "./SuperAdminProtected";
import FeatureFlagGuard from "./FeatureFlagGuard";
const SuperAdminLayout = React.lazy(
  () => import("../pages/SuperAdmin/SuperAdminLayout"),
);

//  Implementação atual do chat
const ChatV2 = lazy(() => import("../pages/Dashboard/ChatV2"));

interface RouteProps {
  path: string;
  component: React.ReactNode;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  { path: "/auth-login", component: <Login /> },
  { path: "/login", component: <Navigate to="/auth-login" replace /> },
  {
    path: "/auth-register",
    component: <Register />,
  },
  { path: "/auth-changepassword/:token", component: <ChangePassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/logout", component: <Logout /> },
  { path: "/auth/google/onboarding", component: <GoogleOnboarding /> },
];

// Routes for authenticated users who haven't completed onboarding
const onboardingRoutes: Array<RouteProps> = [
  { path: "/onboarding", component: <OnboardingWizard /> },
];

const privateRoutes: Array<RouteProps> = [
  // settings and its sub‐routes live under one layout
  { path: "/settings/*", component: <SettingsLayout /> },

  { path: "/pages-starter", component: <StarterPage /> },
  {
    path: "/chat-client",
    component: (
      <FeatureFlagGuard flag="chat_client">
        <Suspense fallback={<ChatLoadingFallback />}>
          <ChatV2 />
        </Suspense>
      </FeatureFlagGuard>
    ),
  },
  {
    path: "/chat-jess",
    component: (
      <FeatureFlagGuard flag="chat_jess">
        <ChatJessPage />
      </FeatureFlagGuard>
    ),
  },
  {
    path: "/channel-session",
    component: (
      <FeatureFlagGuard flag="channel_session">
        <Dashboard />
      </FeatureFlagGuard>
    ),
  },
  { path: "/", component: <Root /> },
  { path: "/auth-create-new-password", component: <CreateNewPassword /> },
  {
    path: "/task-board",
    component: (
      <FeatureFlagGuard flag="task_board">
        <TaskBoardPage />
      </FeatureFlagGuard>
    ),
  },
  {
    path: "/workflows",
    component: (
      <FeatureFlagGuard flag="workflows">
        <ProcessIndex />
      </FeatureFlagGuard>
    ),
  },
  {
    path: "/connectors",
    component: (
      <FeatureFlagGuard flag="connectors">
        <ConnectorsPage />
      </FeatureFlagGuard>
    ),
  },
  {
    path: "/connections",
    component: (
      <FeatureFlagGuard flag="connections">
        <ConnectionsPage />
      </FeatureFlagGuard>
    ),
  },
  { path: "/oauth/callback", component: <OAuthCallback /> },
  {
    path: "/superadmin/*",
    component: (
      <SuperAdminProtected>
        <React.Suspense fallback={<div>Loading...</div>}>
          <SuperAdminLayout />
        </React.Suspense>
      </SuperAdminProtected>
    ),
  },
];

export { publicRoutes, privateRoutes, onboardingRoutes };
